import FEATURES from '@/domain/core/constant/features'

const state = {
    enabledFeatures: [],
    initialized: false
}

export const getters = {
    enabledFeatures: state => state.enabledFeatures,
    isFeatureEnabled: state => feature => state.enabledFeatures.includes(feature),
    isPrintersEnabled: state => state.enabledFeatures.includes(FEATURES.PRINTERS),
    isCouponEnabled: state => state.enabledFeatures.includes(FEATURES.COUPON),
    isLimitedResourcesEnabled: state => state.enabledFeatures.includes(FEATURES.LIMITED_RESOURCES),
    initialized: state => state.initialized
}

export const mutations = {
    setEnabledFeatures(state, features) {
        state.enabledFeatures = features
        state.initialized = true
    }
}

export const actions = {
    initializeFeatures({commit, state}) {
        if (state.initialized) return

        const featuresEnv = process.env.VUE_APP_FEATURES || ''
        const features = featuresEnv
            .split(',')
            .map(f => f.trim())
            .filter(f => f.length > 0 && FEATURES.all().includes(f))

        commit('setEnabledFeatures', features)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
